import { PipeTransform, Pipe } from '@angular/core';
import { formatDistanceToNow, format } from 'date-fns';
import { enUS, de, tr, faIR } from 'date-fns/esm/locale';
import { LocalizationService } from '../services/localization.service';
const langConfig = {
  en: enUS,
  de: de,
  tr: tr,
  fa: faIR,
};
@Pipe({ name: 'dateFormat' })
export class DateFormatPipe implements PipeTransform {
  constructor(private _LocalizationService: LocalizationService) {}

  transform(value, formatS: string, lang?: string): any {
    if (value) {
      let date = new Date(value);
      if (value[0] === '/' && value[value.length - 1] === '/') {
        date = new Date(Number(value.replace(/\D/g, '')));
      }
      return format(date, formatS, { locale: langConfig[lang && lang !== 'none' ? lang : this._LocalizationService.LANGCODE] });
    }
  }
}

@Pipe({ name: 'dateFormatDistance' })
export class DateFormatDistancePipe implements PipeTransform {
  constructor(private _LocalizationService: LocalizationService) {}

  transform(value, lang?: string): any {
    if (value) {
      let date = new Date(value);
      if (value[0] === '/' && value[value.length - 1] === '/') {
        date = new Date(Number(value.replace(/\D/g, '')));
      }
      return formatDistanceToNow(date, { locale: langConfig[lang && lang !== 'none' ? lang : this._LocalizationService.LANGCODE], includeSeconds: true });
    }
  }
}
